export default "__VITE_ASSET__24107fa9__"